import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  ledgerMappingCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";

/**
 * Désactive une association code produit / provider
 * (`DELETE /ProductProviderMappings/{id}`) — réservé à
 * flashpay-superadmin. Seul le code HTTP fait foi (pas de corps typé).
 */
export const useDeleteProductProviderMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["ledger", "product-provider-mappings", "delete"],
    mutationFn: (productProviderMappingId: string) =>
      mutateData({
        url: ledgerEndpoints.productProviderMappings.delete(
          productProviderMappingId
        ),
        method: "DELETE",
      }),
    onSuccess: (_data, productProviderMappingId) => {
      return invalidateAfterMutation(
        queryClient,
        ledgerMappingCacheKeys(productProviderMappingId)
      );
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDeleteProductProviderMapping failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "ledger" }
      );
    },
  });
};
